exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ngx-datatable .datatable-body-cell:focus {\n  outline: none !important;\n  background-color: inherit !important;\n  /* Retain original background color */ }\n\nngx-datatable .datatable-header-cell:focus {\n  outline: none !important;\n  background-color: inherit !important;\n  /* Retain original background color */ }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/main/main-material.scss
// module id = ../../../../../src/app/components/main/main-material.scss
// module chunks = main